import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/search_nodata.png'


const _withScopeId = n => (_pushScopeId("data-v-f93e2a48"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "noDataBox"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */))
const _hoisted_3 = {
  key: 1,
  class: "cellCon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    ($setup.hasReqData && $setup.liveData.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('tips.kkry')), 1 /* TEXT */)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.liveData, (item, index) => {
            return (_openBlock(), _createBlock($setup["MatchCell"], {
              key: index,
              item: item
            }, null, 8 /* PROPS */, ["item"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
  ]))
}